import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import Images from "../../../utils/styles/images";
import messages from "../messages";
import "./style.scss";

/**
 * Copy of the shared list paginator (FundList/Pagination) with one addition: a jump-to-page box.
 *
 * The original renders First / Prev / four numbered buttons / Next / Last. Four buttons is fine for
 * a few dozen pages; funds_nav_history is six figures of rows, which is thousands of pages even at
 * 200 per page, so there has to be a way to reach a page without clicking through to it.
 */
function Pagination(props) {
  const { total, nPageIndex, gotoPage } = props;
  const intl = useIntl();
  const [pageInput, setPageInput] = useState(String(nPageIndex + 1));

  useEffect(() => {
    setPageInput(String(nPageIndex + 1));
  }, [nPageIndex]);

  const totalNumberOfPages = total;

  const handleFirstClick = () => {
    gotoPage(0);
  };

  const handleLastClick = () => {
    let nTotal = total - 1;
    gotoPage(nTotal);
  };

  const handleNextPageClick = () => {
    let nPageNxt = nPageIndex + 1;
    gotoPage(nPageNxt);
  };

  const handlePreviousPageClick = () => {
    let nPagePrevious = nPageIndex - 1;
    gotoPage(nPagePrevious);
  };

  const handlePageClick = buttonPageIndex => {
    gotoPage(buttonPageIndex);
  };

  const handleGoToPage = () => {
    const requested = parseInt(pageInput, 10);
    if (isNaN(requested)) {
      setPageInput(String(nPageIndex + 1));
      return;
    }
    const clamped = Math.min(Math.max(requested, 1), totalNumberOfPages);
    setPageInput(String(clamped));
    gotoPage(clamped - 1);
  };

  const renderPaginationButtons = () => {
    let arrayOfButtons = [];

    // limit the number of shown buttons to 4
    for (let index = 1; index < 5; index += 1) {
      let displayValueForPageIndex = nPageIndex + index;

      if (displayValueForPageIndex <= totalNumberOfPages) {
        arrayOfButtons.push(
          <button
            className={
              displayValueForPageIndex === nPageIndex + 1
                ? "pagination-button-selected"
                : "pagination-button"
            }
            onClick={() => handlePageClick(displayValueForPageIndex - 1)}
            key={"pagination-button" + displayValueForPageIndex}
          >
            {displayValueForPageIndex}
          </button>
        );
      }
    }

    return arrayOfButtons;
  };

  return (
    <div className="pagination-container">
      <button className="pagination-first" onClick={() => handleFirstClick()}>
        <img src={Images.pagination.leftArrow} alt="left-arrow" />
        <img src={Images.pagination.leftArrow} alt="left-arrow" />
      </button>
      <button
        className={
          nPageIndex - 1 < 0 ? "pagination-previous-disabled" : "pagination-previous"
        }
        onClick={() => handlePreviousPageClick()}
        disabled={nPageIndex - 1 < 0}
      >
        <img src={Images.pagination.leftArrow} alt="left-arrow" />
      </button>
      {renderPaginationButtons()}
      <button
        className={
          nPageIndex + 1 >= totalNumberOfPages
            ? "pagination-next-disabled"
            : "pagination-next"
        }
        onClick={() => handleNextPageClick()}
        disabled={nPageIndex + 1 >= totalNumberOfPages}
      >
        <img src={Images.pagination.rightArrow} alt="right-arrow" />
      </button>
      <button className="pagination-last" onClick={() => handleLastClick()}>
        <img src={Images.pagination.rightArrow} alt="right-arrow" />
        <img src={Images.pagination.rightArrow} alt="right-arrow" />
      </button>

      <span className="nav-pagination-goto-label">
        {intl.formatMessage(messages.goToPage)}
      </span>
      <input
        className="nav-pagination-goto-input"
        value={pageInput}
        onChange={event => setPageInput(event.target.value.replace(/[^0-9]/g, ""))}
        onKeyDown={event => {
          if (event.keyCode === 13) {
            handleGoToPage();
          }
        }}
      />
      <button className="nav-pagination-goto-button" onClick={() => handleGoToPage()}>
        {intl.formatMessage(messages.goToPageButton)}
      </button>
      <span className="nav-pagination-total">
        {intl.formatMessage(messages.pageOfTotal, {
          page: nPageIndex + 1,
          pages: totalNumberOfPages
        })}
      </span>
    </div>
  );
}

export default Pagination;
